// extracted by mini-css-extract-plugin
export var cardContainer = "_og-0";
export var cardHeader = "_og-2";
export var collapsedState = "_og-3";
export var dragHandle = "_og-5";
export var dragHandleIcon = "_og-6";
export var dragging = "_og-1";
export var titleArea = "_og-4";